import { Button as MUIButton, ButtonProps } from '@mui/material'
import { ButtonHTMLAttributes } from 'react'
import { unsafeResource } from './UnsafeResource'

export const UnsafeResourceMUIButton = unsafeResource<
  typeof MUIButton,
  ButtonProps & ButtonHTMLAttributes<typeof MUIButton>
>(MUIButton, 'UnsafeResourceMUIButton')
